import { combineReducers } from 'redux';
import societyReducer from "../society.duck";
import countryReducer from "../country.duck";
import loginReducer from "../login.duck";
import collectingEntityReducer from "../collectingEntity.duck";
import branchReducer from "../branch.duck";
import channelReducer from "../channel.duck";
import typeReducer from "../type.duck";
import roleConceptReducer from "../roleConcept.duck";
import accountReducer from "../account.duck";
import limitAmountEntityReducer from "../limitAmountEntity.duck";
import channelTransactionReducer from "../channelTransaction.duck";
import channelEntityPaymentReducer from "../channelEntityPayment.duck";
import MessageReducer from "../message.duck";
import clientReducer from "../client.duck";
import monitorReducer from "../monitor.duck";
import summaryReducer from "../summary.duck";
import connectionSftpReducer from "../connectionSftp.duck";
import templateReducer from "../template.duck";
import detailReducer from "../templateDetail.duck";
import templateAssignationReducer from "../templateAssign.duck";
import conciliationMonitorReducer from "../conciliationMonitor.duck";
import historyReducer from "../history.duck";

export default combineReducers({
    societyReducer: societyReducer,
    countryReducer: countryReducer,
    loginReducer: loginReducer,
    collectingEntityReducer: collectingEntityReducer,
    branchReducer: branchReducer,
    accountReducer: accountReducer,
    limitAmountEntityReducer: limitAmountEntityReducer,
    typeReducer: typeReducer,
    channelReducer: channelReducer,
    roleConceptReducer: roleConceptReducer,
    channelTransactionReducer: channelTransactionReducer,
    channelEntityPaymentReducer: channelEntityPaymentReducer,
    MessageReducer: MessageReducer,
    clientReducer: clientReducer,
    monitorReducer: monitorReducer,
    summaryReducer: summaryReducer,
    connectionSftpReducer: connectionSftpReducer,
    templateReducer: templateReducer,
    detailReducer: detailReducer,
    templateAssignationReducer: templateAssignationReducer,
    conciliationMonitorReducer: conciliationMonitorReducer,
    historyReducer: historyReducer
});
